import { getDataForZipCode } from 'thai-data';

const EMPTY_RESULT = { province: '', provinceOptions: [], amphoe: '', districtOptions: [], tambon: '', subdistrictOptions: [] };

// คำนวณจังหวัด/อำเภอ/ตำบล จากรหัสไปรษณีย์ + ตัวเลือกที่ผู้ใช้เลือกไปแล้ว (เมื่อรหัสไปรษณีย์นั้นกำกวม)
// คำนวณใหม่จากศูนย์ทุกครั้ง (ไม่ใช้ state สะสม) เพื่อไม่ให้พังตอนเปิดฟอร์มแก้ไขข้อมูลเดิมที่ถูกต้องอยู่แล้ว
export function resolveThaiZipCascade(zipCode, selectedProvinceName, selectedDistrictName) {
  const zip = String(zipCode || '').trim();
  if (zip.length !== 5) {
    return { status: 'empty', ...EMPTY_RESULT };
  }

  const data = getDataForZipCode(zip);
  if (!data || !data.provinceList || !data.districtList || !data.subDistrictList) {
    return { status: 'not_found', ...EMPTY_RESULT };
  }

  let province = null;
  let provinceOptions = [];
  if (data.provinceList.length === 1) {
    [province] = data.provinceList;
  } else {
    province = data.provinceList.find((p) => p.provinceName === selectedProvinceName) || null;
    if (!province) provinceOptions = data.provinceList.map((p) => p.provinceName);
  }

  let district = null;
  let districtOptions = [];
  if (province) {
    const districtsInProvince = data.districtList.filter((d) => d.proviceId === province.provinceId);
    if (districtsInProvince.length === 1) {
      [district] = districtsInProvince;
    } else {
      district = districtsInProvince.find((d) => d.districtName === selectedDistrictName) || null;
      if (!district) districtOptions = districtsInProvince.map((d) => d.districtName);
    }
  }

  let subdistrict = null;
  let subdistrictOptions = [];
  if (district) {
    const subsInDistrict = data.subDistrictList.filter((s) => s.districtId === district.districtId);
    if (subsInDistrict.length === 1) {
      [subdistrict] = subsInDistrict;
    } else {
      subdistrictOptions = subsInDistrict.map((s) => s.subDistrictName);
    }
  }

  return {
    status: 'ok',
    province: province ? province.provinceName : '',
    provinceOptions,
    amphoe: district ? district.districtName : '',
    districtOptions,
    tambon: subdistrict ? subdistrict.subDistrictName : '',
    subdistrictOptions,
  };
}

// เช็คตอน submit ว่าจังหวัด/อำเภอ/ตำบล/รหัสไปรษณีย์ ที่กรอกมาสัมพันธ์กันจริงตาม thai-data
// คืนค่า null ถ้าผ่าน หรือ error message ถ้าไม่ตรงกัน — ไม่เช็คถ้าไม่ได้กรอกรหัสไปรษณีย์เลย (ที่อยู่นอกประเทศไทย)
export function validateThaiAddress({ zipcode, province, amphoe, tambon }) {
  const zip = String(zipcode || '').trim();
  if (!zip) return null;
  if (zip.length !== 5) return 'รหัสไปรษณีย์ต้องมี 5 หลัก';

  const data = getDataForZipCode(zip);
  if (!data || !data.provinceList || !data.districtList || !data.subDistrictList) {
    return 'ไม่พบรหัสไปรษณีย์นี้ในระบบ';
  }

  let matchedProvinceId = null;
  if (province) {
    const p = data.provinceList.find((x) => x.provinceName === province);
    if (!p) return `จังหวัด "${province}" ไม่ตรงกับรหัสไปรษณีย์ ${zip}`;
    matchedProvinceId = p.provinceId;
  }

  let matchedDistrictId = null;
  if (amphoe) {
    const d = data.districtList.find((x) => x.districtName === amphoe && (!matchedProvinceId || x.proviceId === matchedProvinceId));
    if (!d) return `อำเภอ "${amphoe}" ไม่ตรงกับจังหวัด/รหัสไปรษณีย์ที่เลือก`;
    matchedDistrictId = d.districtId;
  }

  if (tambon) {
    const s = data.subDistrictList.find((x) => x.subDistrictName === tambon && (!matchedDistrictId || x.districtId === matchedDistrictId));
    if (!s) return `ตำบล "${tambon}" ไม่ตรงกับอำเภอ/รหัสไปรษณีย์ที่เลือก`;
  }

  return null;
}
